export const POLL_LAST_SELECTED_TEACHER_CLASS_ID =
  'POLL_LAST_SELECTED_TEACHER_CLASS_ID';

export const LAST_SELECTED_TEACHER_CLASS_ID = 'LAST_SELECTED_TEACHER_CLASS_ID';

export const ALL_CLASSES = 'all-classes';

export const ALL_SUBJECTS = 'all-subjects';
